
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: '不動産売買',
      description: '戸建て・マンション・土地の売買仲介を行います。お客様のご希望に合わせた物件をご提案いたします。',
      image: 'https://public.readdy.ai/ai/img_res/6a5615ea0362e08a89193a776a37cab0.jpg'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '不動産買取',
      description: '迅速な現金化をご希望の方に最適です。査定から契約まで、スピーディーに対応いたします。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20businessman%20in%20suit%20holding%20house%20model%20and%20documents%2C%20modern%20office%20setting%2C%20confident%20expression%2C%20real%20estate%20consultation%20scene%2C%20clean%20business%20environment%2C%20trustworthy%20appearance&width=400&height=300&seq=service2&orientation=landscape'
    },
    {
      icon: 'ri-search-line',
      title: '無料査定',
      description: '専門スタッフがお客様の不動産を適正価格で査定いたします。査定は無料で承っております。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20real%20estate%20agent%20with%20tablet%20showing%20property%20evaluation%20to%20clients%20in%20bright%20modern%20office%2C%20professional%20consultation%20meeting%2C%20clean%20workspace%2C%20friendly%20business%20atmosphere&width=400&height=300&seq=service3&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            サービス内容
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            岡山市を中心とした地域で、お客様の不動産に関するあらゆるニーズにお応えします
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                    <i className={`${service.icon} text-2xl text-blue-600`}></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">{service.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
